import action from 'utils/actionCreators';

export const CLEAR_REDUCER = 'MANAGEMENT_DASHBOARD/CLEAR_REDUCER';
export const GET_DASHBOARD_REPORTS_REQUEST =
  'MANAGEMENT_DASHBOARD/GET_DASHBOARD_REPORTS_REQUEST';
export const GET_DASHBOARD_REPORTS_SUCCESS =
  'MANAGEMENT_DASHBOARD/GET_DASHBOARD_REPORTS_SUCCESS';
export const GET_DASHBOARD_REPORTS_FAILURE =
  'MANAGEMENT_DASHBOARD/GET_DASHBOARD_REPORTS_FAILURE';

export const ADD_USER_PREFERENCE_REQUEST =
  'MANAGEMENT_DASHBOARD/ADD_USER_PREFERENCE_REQUEST';
export const ADD_USER_PREFERENCE_SUCCESS =
  'MANAGEMENT_DASHBOARD/ADD_USER_PREFERENCE_SUCCESS';
export const ADD_USER_PREFERENCE_FAILURE =
  'MANAGEMENT_DASHBOARD/ADD_USER_PREFERENCE_FAILURE';

export const UPDATE_USER_PREFERENCE_REQUEST =
  'MANAGEMENT_DASHBOARD/UPDATE_USER_PREFERENCE_REQUEST';
export const UPDATE_USER_PREFERENCE_SUCCESS =
  'MANAGEMENT_DASHBOARD/UPDATE_USER_PREFERENCE_SUCCESS';
export const UPDATE_USER_PREFERENCE_FAILURE =
  'MANAGEMENT_DASHBOARD/UPDATE_USER_PREFERENCE_FAILURE';

export const SET_USER_PREFERENCE = 'MANAGEMENT_DASHBOARD/SET_USER_PREFERENCE';

export const ADD_WIDGET = 'MANAGEMENT_DASHBOARD/ADD_WIDGET';
export const REMOVE_WIDGET = 'MANAGEMENT_DASHBOARD/REMOVE_WIDGET';
export const CHANGE_LAYOUT = 'MANAGEMENT_DASHBOARD/CHANGE_LAYOUT';
export const OPEN_WIDGETS_MODAL = 'MANAGEMENT_DASHBOARD/OPEN_WIDGETS_MODAL';
export const CLOSE_WIDGETS_MODAL = 'MANAGEMENT_DASHBOARD/CLOSE_WIDGETS_MODAL';
export const OPEN_FILTER_MODAL = 'MANAGEMENT_DASHBOARD/OPEN_FILTER_MODAL';
export const CLOSE_FILTER_MODAL = 'MANAGEMENT_DASHBOARD/CLOSE_FILTER_MODAL';
export const OPEN_PROJECTS_FILTER_MODAL =
  'MANAGEMENT_DASHBOARD/OPEN_PROJECTS_FILTER_MODAL';
export const CLOSE_PROJECTS_FILTER_MODAL =
  'MANAGEMENT_DASHBOARD/CLOSE_PROJECTS_FILTER_MODAL';
export const FILTER_PROJECTS_WIDGET =
  'MANAGEMENT_DASHBOARD/FILTER_PROJECTS_WIDGET';
export const RESET_PROJECTS_FILTER_FIELDS =
  'MANAGEMENT_DASHBOARD/RESET_PROJECTS_FILTER_FIELDS';

export const UPDATE_FORM_INPUT = 'MANAGEMENT_DASHBOARD/UPDATE_FORM_INPUT';
export const UPDATE_FORM_CHECKBOX = 'MANAGEMENT_DASHBOARD/UPDATE_FORM_CHECKBOX';

export const SELECT_CHART = 'MANAGEMENT_DASHBOARD/SELECT_CHART';
export const SELECT_WIDGET_FIELD = 'MANAGEMENT_DASHBOARD/SELECT_WIDGET_FIELD';
export const FILTER_WIDGETS_BY_DATE =
  'MANAGEMENT_DASHBOARD/FILTER_WIDGETS_BY_DATE';
export const FILTER_WIDGETS = 'MANAGEMENT_DASHBOARD/FILTER_WIDGETS';

export const getDashboardReportsRequest = action(
  GET_DASHBOARD_REPORTS_REQUEST,
  'payload',
);
export const clearReducer = action(CLEAR_REDUCER, 'payload');

export const addUserPreferenceRequest = action(
  ADD_USER_PREFERENCE_REQUEST,
  'payload',
);

export const updateUserPreferenceRequest = action(
  UPDATE_USER_PREFERENCE_REQUEST,
  'payload',
);

export const addWidget = action(ADD_WIDGET, 'payload');
export const removeWidget = action(REMOVE_WIDGET, 'payload');
export const changeLayout = action(CHANGE_LAYOUT, 'payload');
export const openWidgetsModal = action(OPEN_WIDGETS_MODAL);
export const closeWidgetsModal = action(CLOSE_WIDGETS_MODAL);
export const openFilterModal = action(OPEN_FILTER_MODAL, 'payload');
export const openProjectsFilterModal = action(OPEN_PROJECTS_FILTER_MODAL);
export const closeProjectsFilterModal = action(CLOSE_PROJECTS_FILTER_MODAL);
export const updateFormInput = action(UPDATE_FORM_INPUT, 'payload');
export const updateFormCheckbox = action(UPDATE_FORM_CHECKBOX, 'payload');
export const filterProjectsWidget = action(FILTER_PROJECTS_WIDGET, 'payload');
export const resetProjectsFilterFields = action(
  RESET_PROJECTS_FILTER_FIELDS,
  'payload',
);

export const closeFilterModal = action(CLOSE_FILTER_MODAL);
export const selectChart = action(SELECT_CHART, 'payload');
export const selectWidgetField = action(SELECT_WIDGET_FIELD, 'payload');
export const filterWidgetsByDate = action(FILTER_WIDGETS_BY_DATE, 'payload');
export const filterWidgets = action(FILTER_WIDGETS, 'payload');
export const setUserPreference = action(SET_USER_PREFERENCE, 'payload');
